"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const shippingPolicies = [{
  id: "policy-1",
  title: "Delivery Timelines (Dubai vs Northern Emirates)",
  content: "We offer expedited, secure delivery within Dubai, typically arriving within 1-2 business days. For the Northern Emirates, please allow 3-5 business days to ensure our specialized transport teams can properly route and secure your items. All deliveries are scheduled in advance at your convenience."
}, {
  id: "policy-2",
  title: "Customs & Duties for International Imports",
  content: "For our international clientele, NOBILITIES ANTIQUES GENERAL TRADING - L.L.C. provides comprehensive assistance with all necessary export documentation and crating. Please be advised that local customs duties, import taxes, and clearance fees in the destination country remain the responsibility of the recipient."
}, {
  id: "policy-3",
  title: "White-Glove Handling for Antiques",
  content: "Our signature white-glove service guarantees that every piece is meticulously inspected, custom-packed using archival-quality materials, and transported in climate-controlled vehicles. Upon arrival, our trained professionals will carefully uncrate and place the antique in your desired location, removing all packing materials."
}, {
  id: "policy-4",
  title: "Transit Insurance & Security",
  content: "Every acquisition shipped from our gallery is fully insured against loss or damage from the moment it leaves our premises until it is safely delivered and signed for at your door, providing you with complete peace of mind."
}];
export default function ShippingDetails() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    delay: 200
  } as any);
  return <section id="shippingdetails" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-5xl text-foreground tracking-tight mb-6">
            Shipping & <span className="text-primary">Delivery</span>
          </h2>
          <Separator className="w-24 bg-secondary/60 h-[2px] mb-6" />
          <p className="text-muted-foreground max-w-2xl text-lg">
            Ensuring your precious acquisitions from NOBILITIES ANTIQUES GENERAL
            TRADING - L.L.C. arrive safely, securely, and with the utmost care.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div ref={contentRef} className={`col-span-1 md:col-span-8 md:col-start-3 transition-all duration-1000 ease-out delay-150 ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Accordion type="single" collapsible className="w-full border border-secondary/20 rounded-xl p-4 md:p-8 bg-card shadow-sm">
              {shippingPolicies.map((policy, index) => <AccordionItem key={policy.id} value={policy.id} data-index={index} className="border-secondary/30 last:border-0 py-2">
                  <AccordionTrigger className="text-base md:text-lg font-medium text-foreground hover:text-primary transition-colors">
                    {policy.title}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pt-2 pb-6 text-sm md:text-base">
                    {policy.content}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}